module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/onesence-9-bad61df3eceb6daed98471f68737cb96.webp";